import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';

@Module({ name: 'app', namespaced: true })
export default class AppModule extends VuexModule {
    isOnline: boolean = true;

    @Mutation
    public setIsOnline(isOnline: boolean) {
        this.isOnline = isOnline;
    }
}
